<template>
  <div class="content mb-5">
    <t-sub-nav :items="tabNavItems" class="mb-5" />

    <b-row class="mb-6">
      <b-col sm="12" md="6" lg="6">
        <b-form-group
          v-if="!loading"
          class="mb-3"
          label-for="name"
          :label="this.$t('Lookup URL / FQDN')"
          :state="$validateState($v.form.domain)"
        >
          <b-form-input
            id="url"
            data-test-id="tools-test-filtering-url"
            @blur="setValidationInput('domain', $event.target.value)"
            :state="$validateState($v.form.domain)"
            :placeholder="this.$t('Enter URL / FQDN')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.domain.maxLength">
              {{ $t("Must contain at most 200 characters.") }}
            </p>
          </template>
        </b-form-group>
      </b-col>
    </b-row>

    <transition name="fade" mode="out-in">
      <section v-if="Object.keys(contentData).length > 1 && !loading">
        <t-content-box
          :header="contentData.header"
          :items="contentData.items"
          :output="isOutput"
        ></t-content-box>
      </section>
    </transition>
    <t-save-button
      data-test-id="tools-test-filtering-save"
      btn-text="Test"
      :form-model="$v.form"
      :fetching="fetching"
      @submit="onSubmit"
    />
  </div>
</template>

<route>
{
  "name": "MSP Global Test Categorization"
}
</route>

<script>
import { mapActions, mapGetters } from "vuex";
import { maxLength } from "vuelidate/lib/validators";
import TContentBox from "@/components/TContentBox";

export default {
  layout: "msp",
  components: {
    TContentBox,
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("toast", ["displayToast"]),
    ...mapActions("tools", ["checkTestFiltering", "clearCache"]),
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },

    async onSubmit() {
      this.contentData = {};
      this.fetching = true;
      try {
        await this.checkTestFiltering(this.form);
      } catch (err) {
        if (err.response) {
          this.displayToast({
            title: this.$t("Error"),
            message: err.response.data.error,
            duration: 2000,
            variant: "danger",
          });
        }
      } finally {
        this.fetching = false;
        this.$v.form.$reset();
        this.contentData.header = this.$t("Categorization Results");
        this.contentData.items = this.toolsTestFiltering;
        this.clearCache();
      }
    },
  },

  computed: {
    ...mapGetters("authentication", ["selectedUser"]),
    ...mapGetters("tools", ["toolsTestFiltering"]),
  },
  data: function () {
    return {
      loading: true,
      fetching: false,
      isOutput: "",
      form: {
        domain: null,
      },
      contentData: {},
      tabNavItems: this.$secondaryNav.toolsNavItems.msp(),
    };
  },
  validations: {
    form: {
      domain: {
        maxLength: maxLength(200),
      },
    },
  },
  async created() {
    this.setPageTitle(this.$t("Tools"));
    this.loading = false;
  },
  beforeDestroy() {
    this.clearCache();
  },
  mounted() {
    this.setPageSubtitle([
      this.$t(
        "The diagnostic tools allow you to test filtering, to evaluate domains and to recategorize domains."
      ),
    ]);
  },
};
</script>
